<template>
  <div class="shopActivity-container">
    <el-row type="flex" justify="end">
        <el-button
          @click="createDialogVisible = true"
          icon="el-icon-plus"
          type="primary"
          >新建模块
        </el-button>
    </el-row>    

    <common-table :data="moduleList">
      <el-table-column label="图标" prop="temp" align="center"  width="80">
				<template slot-scope="scope">
          <el-image  :src="scope.row.img" fit="contain" class="material-img"></el-image>
				</template>
			</el-table-column>
      <el-table-column prop="moduleName" align="center" label="模块名称" width="200"></el-table-column>
      <el-table-column prop="url" align="center" label="导航路径" ></el-table-column>
      <el-table-column prop="disOrder" align="center" label="显示顺序" width="150"></el-table-column>
      <el-table-column prop="isTab" align="center" label="是否Tab页" width="150">
        <template slot-scope="scope">
          <span >{{scope.row.isTab?'是':'否' }}</span>
				</template>
      </el-table-column>      
      <el-table-column prop="isContent" align="center" label="是否内容类" width="150">
        <template slot-scope="scope">
          <span >{{scope.row.isContent?'是':'否' }}</span>
				</template>
      </el-table-column>
      
      <el-table-column prop="target" align="center" label="操作" width="170">
        <template slot-scope="scope">
          <el-button type="primary" size="small" 
            @click.native.prevent="onItemEditClick(scope.row)" icon="el-icon-edit"
          ></el-button>

          <el-button type="danger" size="small"
             icon="el-icon-delete" @click="onItemDelete(scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </common-table>

    <edit-module-dialog :visible.sync="createDialogVisible"></edit-module-dialog>
    <edit-module-dialog :visible.sync="editDialogVisible" :form-extra="currentItem"></edit-module-dialog>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable";
import EditModuleDialog from "@/views/System/Setting/Module/EditModuleDialog";
import {moduleDelete} from "@/api/setting";
import { mapGetters } from "vuex";
import { getToken } from "@/utils/auth";
import {dealDeleteOperation} from "@/utils/tools";
import { moduleDetail } from "@/api/setting";


export default {
  name: "Module",
  components: { CommonTable, EditModuleDialog}, //,ProductEditDialog
  computed: { ...mapGetters(["moduleList"]) },
  data() {
    return {
      createDialogVisible: false,
      editDialogVisible:false,
      currentItem: {},
    };
  },
  async created() {
    this.search();
  },
  methods: {
    async onItemEditClick(item) {
      const {data} = await moduleDetail({userId: getToken(), moduleId: item.moduleId});
      console.log("sourceItemOperation--------", data);
      this.currentItem = data;

			// this.currentItem = item;
			this.editDialogVisible = true;
    },

    async onItemDelete(item) {
      // console.log(item);
			await dealDeleteOperation({deletePromise: moduleDelete({userId: getToken(), moduleId: item.moduleId})});
			await this.search();
    },

    // onEditItem(item) {
    //   console.log(item);
    //   this.currentItem = item;
    //   this.editOrderDialogVisible = true;
    // },
    // async onDeleteItem(item) {
      // this.currentItem = item;
      // await this.$alert('即将删除该产品', '警告', {
      // 		showCancelButton: true,
      // 		type: "warning",
      // 		confirmButtonText: '确定删除',
      // 		cancelButtonText: '取消',
      // }).then(async () => {
      // 		await productDelete({userId: getToken(), productId: item.productId});
      // 		this.$message.success('删除成功');
      // 		await this.onProductSearch();
      // });
    // },
    async search(){
      await this.$store.dispatch("setting/moduleList", {});
    }
  },
};
</script>

<style scoped>
</style>